import { render, staticRenderFns } from "./PathwayCohortCreateModal.vue?vue&type=template&id=036cdba9&"
import script from "./PathwayCohortCreateModal.vue?vue&type=script&lang=js&"
export * from "./PathwayCohortCreateModal.vue?vue&type=script&lang=js&"
import style0 from "./PathwayCohortCreateModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports